// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.inquiry-header-bar {\n  border-bottom: solid 10px;\n  background: #00368f;\n  color: #ffffff;\n  font-size: 2em;\n  position: relative;\n  width: 100%;\n  height: 60px;\n  display: flex;\n  margin-top: 0.5%;\n  margin-right: 0%;\n  margin-bottom: 0%;\n}\n", ""]);
// Exports
module.exports = exports;
